import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Footer.css";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <footer>
      <p className="footer">
        <small className="footer-copy">copyright </small>
        <FontAwesomeIcon icon={faCopyright}></FontAwesomeIcon> {year}
      </p>
    </footer>
  );
};

export default Footer;
